import type { CollectibleElastic } from "@/services/collectibles/elastic/collectiblesElasticTypes";
import { gettext } from "@/services/translation";

type Param = {
  name: string;
  value: string | number | undefined;
};

export const getCollectibleElasticParams = (colletibleElastic: CollectibleElastic): Param[] => {
  const params: Param[] = [];

  const theme = colletibleElastic.theme;
  if (theme !== null) {
    params.push({
      name: gettext.$gettext("Edice"),
      value: theme.name,
    });
  }

  colletibleElastic.parameters.forEach((param) => {
    const value = param.value === null ? undefined : param.value;
    const name = param.name;
    params.push({ name, value });
  });

  return params;
};
